export class Timespan {
  constructor(public days: number, public hours: number) {}

  get isValid(): boolean {
    return this.days >= 0 && this.hours >= 0 && this.hours <= 23;
  }

  static parse(value: string): Timespan | null {
    if (!value) {
      return null;
    }

    if (value.length < 5) {
      return null;
    }

    const timeStr = value.split(':');
    const timespan = new Timespan(+timeStr[0], timeStr[1] ? +timeStr[1] : 0);

    return timespan.isValid ? timespan : null;
  }

  format(): string {
    if (!this.isValid) {
      return '';
    }

    const formattedDay: string = !this.days ? '00' : this.days < 10 ? `0${this.days}` : this.days.toString();
    const formattedHour: string = this.hours < 10 ? `0${this.hours}` : this.hours.toString();

    return `${formattedDay}:${formattedHour}:00:00`;
  }

  get totalHours(): number {
    return this.days * 24 + this.hours;
  }
}
